import { Button, Form, Input } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";

const AddSalesMan = ({ visibleData, onCloseMethod }: any) => {
  const [form] = Form.useForm();
  const route = useParams();
  const [loading, setLoading] = useState(false);
  const [salesManData, setSalesManData] = useState(undefined);
  const [driverUrl, setDriverUrl] = useState(undefined);
  const [error, setError] = useState("");

  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      mobileNumber: data.mobileNumber,
      name: data.name,
      shopId: (route as any).shopId,
    };

    if (salesManData) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/sales-man`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          id: salesManData?.id,
          mobileNumber: `+88${data?.mobileNumber}`,
          deleted: false,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Sales Man Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/sales-man`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          mobileNumber: `+88${data?.mobileNumber}`,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Sales Man Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    if (visibleData) {
      setSalesManData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (salesManData) {
      form.resetFields(Object.keys(visibleData));
      // setDriverUrl(visibleData?.driverImage);
    }
  }, [salesManData]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          initialValues={{
            ...salesManData,
            mobileNumber: visibleData?.mobileNumber?.replace("+88", ""),
          }}
        >
          <Form.Item
            hasFeedback
            label="Name"
            rules={[
              {
                required: true,
                message: "Name Title is Required!",
              },
            ]}
            name="name"
            style={{ minWidth: "100%" }}
          >
            <Input id="name" type="text" placeholder="Enter Name" />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Mobile Number 01..."
            rules={[
              {
                required: true,
                message: "Mobile Number is required!",
              },
              {
                validator: async (_, names) => {
                  if (!names?.match(/(^(01){1}[3456789]{1}(\d){8})$/)) {
                    return Promise.reject(
                      new Error("Enter valid mobile number")
                    );
                  }
                },
              },
            ]}
            name="mobileNumber"
            initialValue={"01"}
          >
            <Input
              id="mobile"
              type="mobile"
              addonBefore={"+88"}
              placeholder="Enter Mobile Number"
              // allowClear
            />
          </Form.Item>

          {/* <Form.Item
            hasFeedback
            label="Photo"
            rules={[
              {
                required: true,
                message: "Driver Image is required!",
              },
              {
                validator: async (_, value) => {
                  if (value && !validUrl(value)) {
                    return Promise.reject(new Error("Enter valid url"));
                  }
                },
              },
            ]}
            name="driverImage"
          >
            <Input
              id="driverImage"
              type="text"
              placeholder="Enter Driver Url"
              onChange={(e) => {
                setDriverUrl(e.target.value);
              }}
            />
          </Form.Item>

          {driverUrl && (
            <div className="mt-2" style={{ minWidth: "100%" }}>
              <Image
                src={driverUrl}
                height={150}
                className="img img-thumbnail"
                onLoad={(e) => {
                  const width = (e.target as any).naturalWidth;
                  const height = (e.target as any).naturalHeight;
                  const ratio = width / height;

                  if (ratio.toFixed(1) === "2.5" && height > 400) {
                    setError("");
                  } else {
                    setError(
                      "Image Ratio must be around 2.3 & minimum Height is 400"
                    );
                  }
                }}
              />
              <p className="red-txt mt-1">{error}</p>
            </div>
          )} */}
          <div className="buttons-container">
            <Button
              disabled={loading || !!error}
              loading={(loading ? "loading" : undefined) as any}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => {
                form?.resetFields();
                setDriverUrl(undefined);
              }}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddSalesMan;
